import { render } from "./KassensystemMain.vue?vue&type=template&id=cf673162&scoped=true"
import script from "./KassensystemMain.vue?vue&type=script&lang=js"
export * from "./KassensystemMain.vue?vue&type=script&lang=js"

import "./KassensystemMain.vue?vue&type=style&index=0&id=cf673162&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf673162"]])

export default __exports__